import React from 'react'
import { Collapse as AntCollapse } from 'antd'
import {
  CollapseProps as AntCollapseProps,
  CollapsePanelProps as AntCollapsePanelProps
} from 'antd/lib/collapse'

export type CollapseProps = AntCollapseProps
export type CollapsePanelProps = AntCollapsePanelProps
export type PanelProps = {
  isActive?: boolean
  header?: React.ReactNode
  className?: string
  style?: React.CSSProperties
  showArrow?: boolean
  forceRender?: boolean
  disabled?: boolean
  extra?: React.ReactNode
}

const { Panel: AntPanel } = AntCollapse

export const Collapse: React.FC<CollapseProps> = ({
  children,
  accordion,
  activeKey,
  bordered,
  defaultActiveKey,
  className,
  expandIcon,
  expandIconPosition,
  onChange,
  ghost,
  ...props
}) => {
  const controlledProps = {
    ...(activeKey !== undefined && { activeKey })
  }
  return (
    <AntCollapse
      accordion={accordion}
      className={className}
      bordered={bordered}
      defaultActiveKey={defaultActiveKey}
      ghost={ghost}
      expandIcon={expandIcon}
      expandIconPosition={expandIconPosition}
      onChange={onChange}
      {...controlledProps}
      {...props}
    >
      {children}
    </AntCollapse>
  )
}

export const Panel: React.FC<CollapsePanelProps> = ({
  children,
  header,
  key,
  ...props
}) => {
  return (
    <AntPanel header={header} key={key} {...props} forceRender={true}>
      {children}
    </AntPanel>
  )
}
